// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1zdOh","itemTitle":"ClientEmergencyInfo_itemTitle__1GKaR","itemText":"ClientEmergencyInfo_itemText__Gu2Li"};